import { A as AppAvatar } from './index-ec953df8.esm.js';
import React__default, { useState, useRef } from 'react';
import { View, Platform, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppButton } from './AppButton-a3bdb006.esm.js';
import { A as AppText, a as AppIcon } from './index-6b88191c.esm.js';
import { A as AppModal } from './index-9c3f5cad.esm.js';

const AppPopup = _ref => {
  var _currentTheme$theme;
  let {
    children,
    iconSize,
    iconStyle,
    rightIconModalStyle,
    modalRightIconSize = 20,
    onIconPress,
    icon,
    modalBackdrop = false,
    modalBarTitleStyle,
    modalInnerContentStyle,
    modalStyle,
    modalWrapperStyle,
    popupTitle,
    label,
    leftIcon,
    onPress,
    labelStyle,
    labelWrapperStyle,
    labelColor,
    preventTranslation,
    isClickable,
    onPopupShow,
    isHiddenOnMouseLeave,
    placement,
    isTriggerIcon = true,
    btnTitle,
    btnStyle,
    btnBackgroundColor,
    iconColor,
    avatarLabel,
    avatarRatio,
    avatarSize,
    isAvatar,
    topOffset = 0,
    leftOffset = 0,
    isCloseButtonVisible = true,
    isEnabled = true,
    avatarLabelStyle,
    avatarLabelColor,
    avatarStyle,
    isPositionRelativeToTrigger = true,
    ...props
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    currentTheme
  } = useTheme();
  const modalRef = useRef();
  // let lastKnownPositionOfTrigger;
  const [lastKnownPositionOfTrigger, setLastKnownPosition] = useState(null);
  const [popupWidth, setPopupWidth] = useState(0);
  const [popupHeight, setPopupHeight] = useState(0);
  const _styles = styleGenerator({
    isPositionRelativeToTrigger,
    lastKnownPositionOfTrigger,
    width: popupWidth,
    height: popupHeight,
    placement,
    isLabelPresent: label !== null,
    topOffset,
    leftOffset
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      justifyContent: "flex-start"
    }
  }, label && /*#__PURE__*/React__default.createElement(AppText, {
    color: labelColor,
    iconSize: iconSize,
    wrapperStyle: labelWrapperStyle,
    style: labelStyle,
    isHoverable: true,
    onPress: onPress,
    isClickable: onPress || isClickable ? true : false,
    leftIcon: leftIcon,
    preventTranslation: preventTranslation
  }, label), isTriggerIcon ? /*#__PURE__*/React__default.createElement(AppIcon, {
    onLayout: e => {
      setLastKnownPosition(e.nativeEvent.layout);
    },
    size: iconSize,
    style: [_styles.baseIconStyle, iconStyle],
    onPress: e => {
      isEnabled && setIsModalOpen(!isModalOpen);
    },
    icon: icon,
    isClickable: isEnabled,
    color: isEnabled ? iconColor : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.grey
  }) : isAvatar ? /*#__PURE__*/React__default.createElement(AppAvatar, {
    label: avatarLabel || "Not applicable",
    size: avatarSize,
    onPress: e => {
      isEnabled && setIsModalOpen(!isModalOpen);
    },
    labelStyle: avatarLabelStyle,
    avatarLabelColor: avatarLabelColor,
    style: [{
      cursor: Platform.OS === "web" && "pointer"
    }, avatarStyle],
    ratio: avatarRatio,
    onLayout: e => {
      setLastKnownPosition(e.nativeEvent.layout);
    }
  }) : /*#__PURE__*/React__default.createElement(AppButton, {
    onLayout: e => {
      setLastKnownPosition(e.nativeEvent.layout);
    },
    onPress: e => {
      setIsModalOpen(!isModalOpen);
    },
    title: btnTitle,
    style: btnStyle,
    backgroundColor: btnBackgroundColor,
    awesomeIcon: icon,
    awesomeIconColor: iconColor
  })), /*#__PURE__*/React__default.createElement(AppModal, {
    rightIconSize: modalRightIconSize,
    isAppIconLeftAvailable: false,
    barTitleStyle: [_styles.modalBarTitleStyle, modalBarTitleStyle],
    rightIconStyle: [_styles.baseRightIconModalStyle, rightIconModalStyle],
    modalTitle: popupTitle,
    transparent: true,
    isModalVisible: isModalOpen,
    modalInnerContentStyle: [_styles.baseModalInnerContentStyle, modalInnerContentStyle],
    ref: modalRef,
    isCloseButtonVisible: isCloseButtonVisible,
    closeModal: () => setIsModalOpen(false),
    modalWrapperStyle: [_styles.baseModalWrapperStyle, modalWrapperStyle],
    modalStyle: [_styles.baseModalStyle, modalStyle],
    modalBackdrop: modalBackdrop,
    modalBackdropStatic: false,
    onShow: onPopupShow
  }, children));
};
const styleGenerator = _ref2 => {
  let {
    isPositionRelativeToTrigger,
    lastKnownPositionOfTrigger,
    width,
    height,
    placement,
    isLabelPresent,
    topOffset,
    leftOffset
  } = _ref2;
  return StyleSheet.create({
    baseModalWrapperStyle: {
      alignSelf: "flex-start"
    },
    baseRightIconModalStyle: {
      position: "absolute",
      top: -17,
      right: -13
    },
    baseIconStyle: {
      marginLeft: isLabelPresent ? 10 : 0
    },
    baseModalBarTitleStyle: {
      paddingBottom: 10,
      paddingRight: 20
    },
    baseModalInnerContentStyle: {
      paddingTop: 0
    },
    baseModalStyle: {
      alignSelf: "flex-start",
      position: "relative",
      top: isPositionRelativeToTrigger && (lastKnownPositionOfTrigger === null || lastKnownPositionOfTrigger === void 0 ? void 0 : lastKnownPositionOfTrigger.top) - topOffset,
      left: isPositionRelativeToTrigger && (lastKnownPositionOfTrigger === null || lastKnownPositionOfTrigger === void 0 ? void 0 : lastKnownPositionOfTrigger.left) - (placement === "left" ? width : 0) - leftOffset,
      // CHECK NATIVE
      borderRadius: 10
    },
    container: {
      flexDirection: "row"
    }
  });
};
AppPopup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppPopup",
  "props": {
    "modalRightIconSize": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "required": false
    },
    "modalBackdrop": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "isTriggerIcon": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "topOffset": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "required": false
    },
    "leftOffset": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "required": false
    },
    "isCloseButtonVisible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "isEnabled": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "isPositionRelativeToTrigger": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppPopup as A };
